import { render, staticRenderFns } from "./BaseCollectedProduct.vue?vue&type=template&id=b0118a4e&"
import script from "./BaseCollectedProduct.vue?vue&type=script&lang=ts&"
export * from "./BaseCollectedProduct.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCollectedProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports